export default __webpack_public_path__ + "static/media/Atlas Logo - Huge.e19d8d72.svg";